var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiJoystick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x86\xE1\x85\xA5\xE1\x86\xAF\xE1\x84\x90\xE1\x85\xB5\xE1\x84\x8C\xE1\x85\xA9\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x89\xE1\x85\xB3\xE1\x84\x90\xE1\x85\xB5\xE1\x86\xA8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3043 30.9626H25.9476C26.7311 30.9626 27.3672 31.5988 27.3672 32.3823V32.9795H13.8846V32.3823C13.8846 31.5988 14.5208 30.9626 15.3043 30.9626Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1866 32.9832H28.0652C28.8189 32.9832 29.4308 33.5951 29.4308 34.3488V35H11.8209V34.3488C11.8209 33.5951 12.4328 32.9832 13.1866 32.9832Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.2324 7.09619H14.4412C14.3752 7.24802 14.3529 7.4091 14.3853 7.56977L15.7409 14.278C15.9395 15.2608 16.0392 16.2524 16.0392 17.2452V23.3237C16.0392 23.9246 16.7263 24.4118 17.5739 24.4118H23.3576C24.2066 24.4118 24.8943 23.9232 24.8924 23.3213L24.8834 20.414C24.8737 17.3449 25.8167 14.3119 27.6454 11.53L30.123 7.76076C30.2626 7.54831 30.2923 7.31653 30.2324 7.09619Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.098 24.4119H18.1537V31.017H23.098V24.4119Z",
    fill: "#505363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.8551 6.55955L28.2621 5.34663C27.9718 5.12553 27.5649 5 27.1389 5H17.4376C16.9775 5 16.5417 5.14633 16.2502 5.39871L14.7172 6.72597C14.5898 6.83629 14.499 6.96274 14.4412 7.09615H30.2324C30.179 6.89982 30.0558 6.71239 29.8551 6.55955Z",
    fill: "#505363"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.1666 18.5019H11.2453V17.2012C11.2453 16.7616 10.7435 16.5106 10.3918 16.7744L7.54661 18.9083C7.26213 19.1217 7.26213 19.5484 7.54661 19.7618L10.3918 21.8957C10.7435 22.1594 11.2453 21.9085 11.2453 21.4689V20.1685H13.1666C13.6268 20.1685 13.9999 19.7954 13.9999 19.3352C13.9999 18.875 13.6268 18.5019 13.1666 18.5019Z",
    fill: "#196EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.7866 18.9083L30.9413 16.7744C30.5897 16.5106 30.0878 16.7616 30.0878 17.2012V18.5019H28.1666C27.706 18.5019 27.3333 18.875 27.3333 19.3352C27.3333 19.7954 27.706 20.1685 28.1666 20.1685H30.0878V21.4689C30.0878 21.9085 30.5897 22.1594 30.9413 21.8957L33.7866 19.7618C34.071 19.5484 34.071 19.1217 33.7866 18.9083Z",
    fill: "#196EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiJoystick);
export default __webpack_public_path__ + "static/media/multi-joystick.f7f09714b8bf8f2fe466a8819fbcc84d.svg";
export { ForwardRef as ReactComponent };